export default {"src":"/_next/static/media/SOL.fd7e06c0.svg","height":26,"width":32,"blurWidth":0,"blurHeight":0};